import React from "react";
import {
  Box,
  Typography,
  IconButton,
  InputBase,
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  ListItemIcon,
  Divider,
  Paper,
  Grid,
  Button,
  Tabs,
  Tab
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useAuth } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import ConfirmDeleteModal from "../../../usuarios/components/profileCard/common/ConfirmDeleteModal";

const SEARCH_API = "https://apiweb.hitpoly.com/ajax/buscarProfesionalesController.php";
const USERS_API = "https://apiweb.hitpoly.com/ajax/traerUsuariosController.php";
const RECOMMENDATIONS_API = "https://apiweb.hitpoly.com/ajax/personaRecomendadaController.php";

const ProfessionalSearchView = ({ onClose }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [recentSearches, setRecentSearches] = useState([]);
  const [suggestedPeople, setSuggestedPeople] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [viewAll, setViewAll] = useState(null); // 'history' o 'suggested'
  const [historyTab, setHistoryTab] = useState(0); // 0: Todo, 1: Búsquedas, 2: Visitas
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const currentUserId = user?.user_id || user?.id;

  useEffect(() => {
    if (currentUserId) {
      fetchHistory();
      fetchRecommendations();
    }
  }, [currentUserId]);

  const fetchHistory = async () => {
    try {
      const response = await axios.post(SEARCH_API, {
        accion: "getRecentHistory",
        user_id: currentUserId
      });
      if (response.data.success) {
        setRecentSearches(response.data.datos || []);
      }
    } catch (error) {
    }
  };

  const fetchRecommendations = async () => {
    try {
      const response = await axios.post(RECOMMENDATIONS_API, {
        accion: "getSuggestions",
        viewer_id: currentUserId
      });
      if (response.data.success) {
        setSuggestedPeople(response.data.datos || []);
      }
    } catch (error) {
    }
  };

  const handleSearch = async (val) => {
    setSearchTerm(val);
    if (val.length < 2) {
      setSearchResults([]);
      return;
    }

    try {
      const response = await axios.post(SEARCH_API, {
        accion: "saveAndSearch",
        query: val,
        viewer_id: currentUserId
      });
      if (response.data.success) {
        setSearchResults(response.data.datos || []);
      }
    } catch (error) {
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && searchTerm.trim().length > 0) {
      axios.post(SEARCH_API, {
        accion: "saveSelection",
        user_id: currentUserId,
        query: searchTerm,
        type: "search",
        target_id: null
      });
      // Opcional: podrías cerrar el buscador o mostrar resultados
    }
  };

  const saveHistoryAndNavigate = async (targetUser, type = "visit") => {
    const query = `${targetUser.nombre} ${targetUser.apellido}`;
    try {
      await axios.post(SEARCH_API, {
        accion: "saveSelection",
        user_id: currentUserId,
        query: query,
        type: type,
        target_id: targetUser.id
      });
    } catch (error) {
    }

    const slug = `${targetUser.nombre.toLowerCase()}.${targetUser.apellido.toLowerCase()}`.replace(/\s+/g, '');
    navigate(`/${slug}`, { state: { targetId: targetUser.id } });
    onClose();
  };

  const handleViewAll = async (type) => {
    setViewAll(type);
    if (type === 'history') {
      try {
        const response = await axios.post(SEARCH_API, {
          accion: "getFullHistory",
          user_id: currentUserId
        });
        if (response.data.success) {
          setRecentSearches(response.data.datos || []);
        }
      } catch (error) { }
    } else if (type === 'suggested') {
      try {
        const response = await axios.post(RECOMMENDATIONS_API, {
          accion: "getSuggestions",
          viewer_id: currentUserId,
          limit: 30
        });
        if (response.data.success) {
          setSuggestedPeople(response.data.datos || []);
        }
      } catch (error) { }
    }
  };

  const handleClearHistory = async () => {
    try {
      const response = await axios.post(SEARCH_API, {
        accion: "clearHistory",
        user_id: currentUserId
      });
      if (response.data.success) {
        setRecentSearches([]);
        setShowConfirm(false);
      }
    } catch (error) {
    }
  };

  if (viewAll) {
    const filteredHistory = recentSearches.filter(item => {
      if (historyTab === 0) return true;
      if (historyTab === 1) return item.type === 'search';
      if (historyTab === 2) return item.type === 'visit';
      return true;
    });

    return (
      <Box sx={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", bgcolor: "#fff", zIndex: 120000, display: "flex", flexDirection: "column" }}>
        {/* Header con Borrar todo */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1, borderBottom: "1px solid #f0f0f0" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={() => setViewAll(null)} sx={{ mr: 1 }}><ArrowBackIcon /></IconButton>
            <Typography variant="h6" fontWeight="bold">
              {viewAll === 'history' ? "Historial" : "Sugerencias"}
            </Typography>
          </Box>
          {viewAll === 'history' && (
            <Button 
              variant="text" 
              onClick={() => setShowConfirm(true)}
              sx={{ textTransform: "none", color: "#1877f2", fontWeight: "bold" }}
            >
              Borrar todo
            </Button>
          )}
        </Box>

        {viewAll === 'history' && (
          <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
            <Tabs value={historyTab} onChange={(e, v) => setHistoryTab(v)} variant="fullWidth">
              <Tab label="Todo" sx={{ textTransform: "none", fontWeight: "bold" }} />
              <Tab label="Búsquedas" sx={{ textTransform: "none", fontWeight: "bold" }} />
              <Tab label="Visitas" sx={{ textTransform: "none", fontWeight: "bold" }} />
            </Tabs>
          </Box>
        )}

        <Box sx={{ flexGrow: 1, overflowY: "auto", p: 1 }}>
          {viewAll === 'history' ? (
            <List sx={{ pt: 0 }}>
              {filteredHistory.map((item, idx) => (
                <ListItem 
                  key={idx} 
                  disablePadding
                  secondaryAction={
                    <IconButton edge="end"><CloseIcon sx={{ fontSize: 20, color: "#999" }} /></IconButton>
                  }
                >
                  <ListItemButton
                    sx={{ py: 1.5 }}
                    onClick={() => {
                      if (item.type === 'visit') {
                        navigate(`/${item.nombre}.${item.apellido}`.toLowerCase().replace(/\s+/g, ''), { state: { targetId: item.target_id } });
                        onClose();
                      } else {
                        handleSearch(item.query);
                        setViewAll(null);
                      }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 50 }}>
                      {item.type === 'visit' ? (
                        <Avatar src={item.avatar} sx={{ width: 40, height: 40, bgcolor: "#f0f2f5", color: "#1877f2" }}>
                          {item.query?.charAt(0)}
                        </Avatar>
                      ) : (
                        <Box sx={{ width: 40, height: 40, borderRadius: "50%", bgcolor: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <AccessTimeIcon sx={{ color: "#65676b" }} />
                        </Box>
                      )}
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.query} 
                      primaryTypographyProps={{ fontSize: "1rem", fontWeight: 500, color: "#050505" }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          ) : (
            <Grid container spacing={2}>
              {suggestedPeople.filter(p => p.avatar && p.avatar.includes('http') && !p.avatar.includes('ui-avatars.com') && !p.avatar.includes('cloudinary.com')).map((person) => (
                <Grid item xs={6} key={person.id}>
                  <Paper elevation={0} onClick={() => saveHistoryAndNavigate(person)} sx={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden", cursor: "pointer" }}>
                    <Box sx={{ position: "relative", pt: "100%", bgcolor: "#f0f2f5" }}>
                      {person.avatar ? (
                        <Box component="img" src={person.avatar} onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                      ) : null}
                      <Box sx={{ display: person.avatar ? "none" : "flex", position: "absolute", top: 0, left: 0, width: "100%", height: "100%", alignItems: "center", justifyContent: "center", bgcolor: "#e0e0e0", color: "#8b5cf6" }}>
                        <Typography variant="h4" fontWeight="bold">{person.nombre?.charAt(0)}</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ p: 1 }}>
                      <Typography variant="body2" fontWeight="bold" noWrap>{person.nombre} {person.apellido}</Typography>
                      <Typography variant="caption" color="text.secondary" noWrap display="block">{person.cargo_nombre || "Miembro"}</Typography>
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>

        <ConfirmDeleteModal 
          open={showConfirm}
          onClose={() => setShowConfirm(false)}
          onConfirm={handleClearHistory}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#fff",
        zIndex: 110000, // Very high to be above everything
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      {/* Search Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 15px",
          borderBottom: "1px solid #f0f0f0"
        }}
      >
        <IconButton onClick={onClose} sx={{ color: "#333", mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Paper
          elevation={0}
          sx={{
            flexGrow: 1,
            backgroundColor: "#f0f2f5",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            padding: "2px 15px",
            height: "40px"
          }}
        >
          <InputBase
            placeholder="Buscar profesionales..."
            fullWidth
            autoFocus
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            onKeyPress={handleKeyPress}
            sx={{ fontSize: "0.95rem" }}
          />
        </Paper>
      </Box>

      {/* Content */}
      <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
        {/* Resultados de Búsqueda Activa */}
        {searchTerm.length >= 2 && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Resultados
            </Typography>
            <List>
              {searchResults.length > 0 ? (
                searchResults.filter(p => p.avatar && p.avatar.includes('http') && !p.avatar.includes('ui-avatars.com') && !p.avatar.includes('cloudinary.com')).map((person) => (
                  <ListItem
                    key={person.id}
                    disablePadding
                    sx={{ mb: 0.5 }}
                  >
                    <ListItemButton
                      onClick={() => saveHistoryAndNavigate(person)}
                      sx={{ borderRadius: "8px" }}
                    >
                    <ListItemAvatar>
                      <Avatar 
                        src={person.avatar} 
                        alt={person.nombre}
                        imgProps={{
                          onError: (e) => { e.target.src = ""; e.target.style.display = "none"; }
                        }}
                      >
                        {person.nombre?.charAt(0)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`${person.nombre} ${person.apellido}`}
                      secondary={
                        (person.ciudad || person.pais) 
                          ? `${person.ciudad || ""}${person.ciudad && person.pais ? ", " : ""}${person.pais || ""}`
                          : "Profesional de Hitpoly"
                      }
                    />
                    </ListItemButton>
                  </ListItem>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
                  No se encontraron resultados.
                </Typography>
              )}
            </List>
            <Divider sx={{ my: 2 }} />
          </Box>
        )}
        {/* Recientes Section */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              Recientes
            </Typography>
            <Typography 
              variant="body2" 
              onClick={() => handleViewAll('history')}
              sx={{ color: "#1877f2", fontWeight: "500", cursor: "pointer" }}
            >
              Ver todo
            </Typography>
          </Box>
          <List sx={{ pt: 0 }}>
            {recentSearches.length > 0 ? (
              recentSearches.map((item, idx) => (
                <ListItem
                  key={idx}
                  disablePadding
                  sx={{ mb: 1.5 }}
                  onClick={() => handleSearch(item.query)}
                >
                  <ListItemAvatar sx={{ minWidth: 48 }}>
                    <Avatar sx={{ width: 40, height: 40, bgcolor: "#f0f2f5", color: "#666" }}>
                      <AccessTimeIcon fontSize="small" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="body1" sx={{ fontWeight: "500", fontSize: "0.95rem" }}>
                        {item.query}
                      </Typography>
                    }
                  />
                </ListItem>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No hay búsquedas recientes.
              </Typography>
            )}
          </List>
        </Box>

        {/* Personas que quizá conozcas Section */}
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              Personas que quizá conozcas
            </Typography>
            <Typography 
              variant="body2" 
              onClick={() => handleViewAll('suggested')}
              sx={{ color: "#1877f2", fontWeight: "500", cursor: "pointer" }}
            >
              Ver todo
            </Typography>
          </Box>
          
          <Box sx={{ display: "flex", gap: 2, overflowX: "auto", pb: 2, "&::-webkit-scrollbar": { display: "none" } }}>
            {suggestedPeople.filter(p => p.avatar && p.avatar.includes('http') && !p.avatar.includes('ui-avatars.com') && !p.avatar.includes('cloudinary.com')).map((person) => (
              <Paper
                key={person.id}
                elevation={0}
                onClick={() => saveHistoryAndNavigate(person)}
                sx={{
                  minWidth: 160,
                  width: 160,
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer"
                }}
              >
                <Box sx={{ position: "relative", width: "100%", height: 160, bgcolor: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {person.avatar ? (
                    <Box
                      component="img"
                      src={person.avatar}
                      onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                      sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : null}
                  <Box 
                    className="avatar-fallback"
                    sx={{ 
                      display: person.avatar ? "none" : "flex", 
                      width: "100%", height: "100%", 
                      alignItems: "center", justifyContent: "center",
                      bgcolor: "#e0e0e0", color: "#8b5cf6"
                    }}
                  >
                    <Typography variant="h3" fontWeight="bold">{person.nombre?.charAt(0)}</Typography>
                  </Box>
                </Box>
                <Box sx={{ p: 1.5, flexGrow: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: "bold", lineHeight: 1.2, mb: 0.5, height: "2.4em", overflow: "hidden" }}>
                    {person.nombre} {person.apellido}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                    {person.cargo_nombre || "Profesional de Hitpoly"}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <CheckCircleIcon sx={{ fontSize: 14, color: "#8b5cf6" }} />
                    <Typography variant="caption" sx={{ fontSize: "0.7rem", color: "#666" }}>
                      Miembro activo
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfessionalSearchView;
